/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI75610ResPropertyListItem {
  
  /** 道具名称 */
  propName?: string;
  
  /** 描述 */
  description?: string;
  
  /** 归属部门 */
  department?: string;
  
  /** 联系人 */
  contact?: string;
  
};
    
  



export interface API75610Req {
  
  /** 道具名称 */
  propName?: string;
  /** 道具描述 */
  propDesc?: string;
  /** 联系人 */
  userId?: string;
};



export interface API75610Res {
  /** 动作名称  */
  actionName?: string;
  /** 道具列表 ,RobotPropertyInfoResult  */
  propertyList?: IAPI75610ResPropertyListItem[];
  
};


// 接口函数 75610 录入道具

export interface IUsePostAPI75610Return {
  /** 录入道具: 接口请求状态 */
  isAPI75610Loading: boolean;
  /** 录入道具: 接口请求返回数据 */
  dataAPI75610: API75610Res;
  /**  录入道具: 接口数据请求方法 */
  fetchAPI75610Data: (inputs: API75610Req, config?: YWRequestConfig) => Promise<API75610Res>;
  /** 录入道具: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI75610 = ():IUsePostAPI75610Return => {
  let isMount = true;
  const [isAPI75610Loading, setIsAPI75610Loading] = useState(false);
  const [dataAPI75610, setDataAPI75610] = useState<API75610Res>({} as API75610Res);
  const requestUrl = `${basePath}/yoaichat-web/robot/property/upload`;

  const fetchAPI75610Data = async (inputs: API75610Req, config?: YWRequestConfig): Promise<API75610Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API75610Req>) || {}) as API75610Req;
    
  
    if ( isMount ) {
      setIsAPI75610Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API75610Res>(`${basePath}/yoaichat-web/robot/property/upload`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI75610(res || {} as API75610Res);
        setIsAPI75610Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI75610Loading(false);
      }
      return false as unknown as API75610Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI75610Loading,
    dataAPI75610,
    fetchAPI75610Data,
    requestUrl,
  }
}

